import { setupServiceWorker } from './pwa/sw-registration';
import { attachNativeBackButton } from './native/backButton';
import './ui/InstallPrompt';
import Phaser from 'phaser';
import { LOGICAL_WIDTH, LOGICAL_HEIGHT, RENDER_SCALE } from './dimensions';
import { BootScene } from './scenes/BootScene';
import { TitleScene } from './scenes/TitleScene';
import { GameScene } from './scenes/GameScene';
import { HudScene } from './scenes/HudScene';
import { BurnTransitionScene } from './scenes/BurnTransitionScene';
import { TokenMachineScene } from './scenes/TokenMachineScene';
import { palette } from './design/palette';
import './ui/style.css';

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'app',
  backgroundColor: palette.bgFrom,
  roundPixels: true,
  scale: {
    mode: Phaser.Scale.FIT,
    // Centering is handled by `#app { display: grid; place-items: center }` in style.css.
    // Phaser's CENTER_BOTH sets margin-left in pixels, which compounds with grid centering
    // and shifts the canvas off-center in wide viewports.
    autoCenter: Phaser.Scale.NO_CENTER,
    width: LOGICAL_WIDTH * RENDER_SCALE,
    height: LOGICAL_HEIGHT * RENDER_SCALE
  },
  physics: {
    default: 'matter',
    matter: {
      gravity: { x: 0, y: 0.8 },
      enableSleeping: false,
      debug: false
    }
  },
  input: { activePointers: 3 },
  scene: [BootScene, TitleScene, GameScene, HudScene, TokenMachineScene, BurnTransitionScene]
};

// Phaser Text rasterizes to its own canvas at resolution=1 by default; under our camera
// zoom of RENDER_SCALE the rendered text would be sampled at zoom (= blurry). Patching the
// factory once so every `scene.add.text(...)` is created at supersampled resolution avoids
// having to thread setResolution() through every call site.
const origText = Phaser.GameObjects.GameObjectFactory.prototype.text;
Phaser.GameObjects.GameObjectFactory.prototype.text = function (x, y, text, style) {
  const t = origText.call(this, x, y, text, style);
  t.setResolution(RENDER_SCALE);
  return t;
};

setupServiceWorker();
const game = new Phaser.Game(config);
attachNativeBackButton(game);
